import '../../styles/CommentsBoxReadonly.css';

import React from 'react';

interface CommentsBoxReadonlyProps {
  title: string;
  value: string;
}

const CommentsBoxReadonly: React.FC<CommentsBoxReadonlyProps> = ({ title, value }) => {
  return (
    <div className="comments-box-readonly">
      <h4>{title}</h4>
      <div className="comments-textarea-readonly">
        {value || 'No comments'}
      </div>
    </div>
  );
};

export default CommentsBoxReadonly; 